export default __webpack_public_path__ + "pytorch.3c5773ae.png";